import API from "../../api/api";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const MiWalletService = {
    callTiles: async () => {
        return callApi("mi-wallet-tiles");
    },
    callStatement: async (page, itemsPerPage, sortBy, direction) => {
        return callApi(
            `mi-wallet-statement?page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    // callTransferHistory: async (
    //     page,
    //     itemsPerPage,
    //     selectedCategory,
    //     startDate,
    //     endDate,
    //     sortBy,
    //     direction
    // ) => {
    //     return callApi(
    //         `/ewallet-transfer-history?type=${selectedCategory}&startDate=${startDate}&endDate=${endDate}&page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy}&direction=${direction}`
    //     );
    // },
   
    callMyEarnings: async (
        page,
        itemsPerPage,
        selectedCategory,
        startDate,
        endDate,
        sortBy,
        direction
    ) => {
        return callApi(
            `mi-wallet-my-earnings?page=${page}&perPage=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}&type=${selectedCategory}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    // callEwalletBalance: async () => {
    //     return callApi("get-ewallet-balance");
    // },
   
};
